import { useQuery } from '@tanstack/react-query'

import { PluginsAPI } from '@makyoapp/makyo-sdk'
import { Order } from '@makyoapp/makyo-sdk/api/api'
import { ProjectPrivacyAPI } from '@makyoapp/makyo-sdk/api/Projects'
import { PluginCategories, PluginOrderBy } from '@makyoapp/makyo-sdk/models/Plugins'

import { queryKeys } from '@/lib/react-query'

type GetPluginParams = {
  page?: number
  search?: string
  order?: Order
  orderBy?: PluginOrderBy
  categories?: PluginCategories[]
  isMakyo?: '' | 'true' | 'false'
}

/**
 * Get plugin list accross makyo platform
 */
export const useGetPlugins = (queryParams: GetPluginParams) => {
  const params = {
    page: 1,
    search: '',
    order: Order.Desc,
    orderBy: PluginOrderBy.CreatedAt,
    categories: [],
    ...queryParams,
  }

  return useQuery({
    queryKey: [queryKeys.pluginList, { ...params }],
    queryFn: () => {
      return PluginsAPI.ReqList(
        params.page,
        params.search,
        params.order,
        params.orderBy,
        params.categories,
        params.isMakyo
      )
    },
  })
}

/**
 * Get plugin form
 */
export const useGetPluginForm = (appID: string) => {
  return useQuery({
    queryKey: [queryKeys.pluginForm, appID],
    queryFn: () => {
      return ProjectPrivacyAPI.ReqGetAppAuthForm(appID)
    },
  })
}
